// extracted by mini-css-extract-plugin
export default {"wrapper":"Advt_wrapper__pEhT+","title":"Advt_title__hdDXv","qrsWrapper":"Advt_qrsWrapper__OQBHd","qrCode":"Advt_qrCode__yfEIb"};